import { getOdor } from '../../../api/elasticSearch/odorApi'
import Utils from '../../../utils/utils'

const state = {
  odorData: [],
}
const getters = {
  getOdorData: state => {
    return state.odorData
  },
}
const actions = {
  async getOdorData({ commit }, condition) {
    commit('odorData', await getOdor(condition))
  },
}
const mutations = {
  odorData(state, data) {
    state.odorData = data
  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
